import { render, staticRenderFns } from "./verifyClient.vue?vue&type=template&id=2b0bdb0b&scoped=true&"
import script from "./verifyClient.vue?vue&type=script&lang=js&"
export * from "./verifyClient.vue?vue&type=script&lang=js&"
import style0 from "./verifyClient.vue?vue&type=style&index=0&id=2b0bdb0b&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b0bdb0b",
  null
  
)

export default component.exports